import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const ReviewOrder = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/plansandFeature/orderReview')(ReviewOrder);
